import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';
import { push } from 'react-router-redux';

import './Auth.css';
import logoUrl from 'assets/img/logo-black.png';

class Auth extends React.Component {
  static propTypes = {
    authModalMode: PropTypes.string
  };
  
  state = {
    email: '',
    password: '',
    _isBusy: false,
    formError: ''
  };

  componentDidMount() {
    if (this.props.auth.isLoaded && !this.props.auth.isEmpty) {
      this.props.dispatch(push('/companies'));
    } else if (this.props.auth.isLoaded && this.props.auth.isEmpty) {
      this.props.dispatch(push('/'));
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.auth.isEmpty && this.props.auth.isEmpty) {
      this.props.dispatch(push('/companies'));
    }
  }

  clearFields() {
    this.setState({ email: '', password: '', formError: '' });
  }

  handleChangeInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleLogin();
    }
  }

  handleLogin = () => {
    if (this.state.email && this.state.password) {
      this.setState({_isBusy: true});
      const creds = { email: this.state.email, password: this.state.password };
      this.props.firebase.login(creds).then(
        () => {
          this.clearFields();
          this.setState({_isBusy: false});
        },
        (error) => {
          if (error.code ==='auth/user-not-found') {
            this.setState({_isBusy: false, formError: 'Email address was not found. Please try again.', password: ''});
          } else if (error.code === 'auth/invalid-email') {
             this.setState({_isBusy: false, formError: 'Email address is badly formatted. Please try again.', password: ''});
          } else if (error.code === 'auth/wrong-password') {
            this.setState({_isBusy: false, formError: 'Incorrect password. Please try again.'});
          } else {
            this.setState({_isBusy: false});
          }
        }
      );
    }
    else {
      this.setState({ formError: !this.state.email ? 'Email field is empty' : 'Password field is empty' });
    }
  }
  
  render() {
    return (
      <div className='Auth-root'>
        <img className='Auth-headerImage' src={logoUrl} alt='' />
        <form className='Auth-form' onSubmit={this.handleLogin}>
          <input
            name='email'
            type='email'
            placeholder='EMAIL'
            value={this.state.email}
            onChange={this.handleChangeInput}
            onKeyPress={this.handleKeyPress}
          />
          <input 
            name='password' 
            type='password'
            placeholder='PASSWORD'
            value={this.state.password}
            onChange={this.handleChangeInput}
            onKeyPress={this.handleKeyPress}
          />
          <p className='Auth-error'>{this.state.formError || null}</p>          
          <button type='button' disabled={this.state._isBusy} onClick={this.handleLogin}>
            LOG IN
          </button>
        </form>
      </div>
    );
  }
}

const connectedAuth = connect(
  (state, props) => ({
    auth: state.firebase.auth
  })
)(Auth);

const wrappedAuth = firebaseConnect()(connectedAuth);

export default wrappedAuth;


// WEBPACK FOOTER //
// ./src/components/auth/Auth/Auth.js